module.exports = __webpack_public_path__ + "img/7_no.c8ddee61.svg";